const ImageTitleDescriptionBlock = {
    baseStyle: {
        // Container with image - responsive flex direction
        container: {
            width: '100%',
            mb: 12
        },
        // Container without image - simple vertical layout
        containerNoImage: {
            width: '100%',
            mb: 12
        },
        // Main wrapper - changes direction based on screen size
        wrapper: {
            direction: {base: 'column', lg: 'row'}, // Vertical on mobile, horizontal on desktop
            gap: {base: 4, lg: '65px'},
            align: {base: 'center', lg: 'flex-start'},
            w: '100%'
        },
        // Image wrapper
        imageWrapper: {
            flexShrink: 0,
            w: {base: '100%', lg: 'auto'},
            maxW: {base: '100%', lg: '50%'}
        },
        // Image container styles
        imageContainer: {
            w: '170px',
            h: '48px'
        },
        // Image styles
        image: {
            w: '170px',
            h: '48px',
            objectFit: 'cover'
        },
        // Content wrapper for title and description
        contentWrapper: {
            flex: 1,
            w: {base: '100%', lg: 'auto'},
            textAlign: {base: 'center', lg: 'left'}
        },
        // Default title styles (can be overridden by CMS styles) - always underlined
        title: {
            fontSize: 'md',
            fontWeight: 'bold',
            mb: 3,
            color: 'black',
            textDecoration: 'underline'
        },
        // Default description styles (can be overridden by CMS styles)
        description: {
            fontSize: 'sm',
            color: 'gray.700',
            lineHeight: '1.5'
        }
    },
    variants: {},
    sizes: {}
}

export default ImageTitleDescriptionBlock